import { action, makeObservable, observable } from "mobx";
import { ClinicFragment } from "../graphql/types-and-hooks";

export interface ClinicIds {
    groupCRM: string
    userFK: string
    locationId: string
}
class ClinicStore {
    @observable clinics: ClinicFragment[];
    @observable selectedClinicIds: ClinicIds | undefined = undefined;

    @observable currentClinic: ClinicFragment;

    constructor() {
        makeObservable(this)
    }

    @action
    setCurrentClinic = (clinic: ClinicFragment) => {
        this.currentClinic = clinic;
    }

    @action
    setCurrentClinicIds = (clinicIds: ClinicIds) => {
        this.selectedClinicIds = clinicIds;
    }
}

export const clinicStore = new ClinicStore();